"use strict";
/// <reference types="../typings/pure-color" />
Object.defineProperty(exports, "__esModule", { value: true });
